import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../services/param.service';
import { PqrFilter } from '../../../../../shared/types/modules/pqr';

export const usePqrHistoryFilters = (onFilter?: (data: PqrFilter) => void) => {
    const [status, setStatus] = useState<ISelect[]>([]);
    const [reconsiderations, setReconsiderations] = useState<ISelect[]>([]);

    const onSubmit = (data: PqrFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setStatus(params)
        );
        asyncGetParams(ParamEnum.PQR_REPLICA).then((params) =>
            setReconsiderations(params)
        );
    }, []);

    return {
        formik,
        status,
        reconsiderations,
    };
};
